import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { forgotPassword } from 'actions/users';
import DeviseLayout from './DeviseLayout';

class ForgotPasswordPage extends React.Component {
  static propTypes = {
    // actions
    forgotPassword: PropTypes.func.isRequired,
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.forgotPassword({ email: this.email.value });
  }

  render() {
    return (
      <DeviseLayout title='Sparkler - Forgot Password' subTitle='Forgot Password?' cta='Send me reset password instructions' onSubmit={this.onSubmit}>
        <input
          name='sp-login-email'
          ref={_ref => this.email = _ref}
          autoCapitalize="none"
          type="email"
          placeholder="Email"
        />
      </DeviseLayout>
    );
  }
}

export default connect(null, { forgotPassword })(ForgotPasswordPage)
